import { format } from "date-fns";

const anyTimeStart = new Date(2021, 1, 1, 0, 1);
const anyTimeEnd = new Date(2021, 1, 1, 24, 0);
const morningStart = anyTimeStart;
const morningEnd = new Date(2021, 1, 1, 13, 0);
const afternoonStart = new Date(2021, 1, 1, 11, 0);
const afternoonEnd = new Date(2021, 1, 1, 18, 0);
const eveningStart = new Date(2021, 1, 1, 17, 0);
const eveningEnd = anyTimeEnd;

export function anyTimeLabel(locale, timeFormat) {
  return `(${format(anyTimeStart, timeFormat, { locale: locale })} - ${format(
    anyTimeEnd,
    timeFormat,
    { locale }
  )})`;
}

export function morningLabel(locale, timeFormat) {
  return `(${format(morningStart, timeFormat, { locale: locale })} - ${format(
    morningEnd,
    timeFormat,
    { locale }
  )})`;
}

export function afternoonLabel(locale, timeFormat) {
  return `(${format(afternoonStart, timeFormat, { locale: locale })} - ${format(
    afternoonEnd,
    timeFormat,
    { locale }
  )})`;
}

export function eveningLabel(locale, timeFormat) {
  return `(${format(eveningStart, timeFormat, { locale: locale })} - ${format(
    eveningEnd,
    timeFormat,
    { locale }
  )})`;
}
